import { WORKFLOW_STEPS } from '@/data/indexSections';

export function WorkflowSection() {
  return (
    <section
      id="workflow"
      aria-labelledby="workflow-title"
      className="relative overflow-hidden bg-white"
    >
      <div className="inner split-grid">
        <div className="reveal relative w-full max-w-[578px]">
          {/* 흐름 배경 리본 (장식) */}
          <img
            src="/assets/images/flow-ribbon.png"
            alt=""
            aria-hidden="true"
            width="1167"
            height="228"
            className="pointer-events-none absolute top-[50px] left-14 z-0 w-[1167px] max-w-none"
            loading="lazy"
          />

          <ol className="relative z-10 grid grid-cols-3 gap-x-16 gap-y-12" role="list">
            {WORKFLOW_STEPS.map((step) => (
              <li key={step.icon} className="step-card reveal">
                <img
                  src={`/assets/icons/${step.icon}.png`}
                  alt=""
                  aria-hidden="true"
                  width={step.width}
                  height={step.height}
                  className="step-card-icon"
                  loading="lazy"
                />
                <p className="step-card-title">{step.title}</p>
                <p className="step-card-sub">{step.sub}</p>
              </li>
            ))}
          </ol>

          {/* 단계 화살표 (장식) — CSS 가 nth-of-type 으로 위치를 잡는다 */}
          <span className="step-arrow" aria-hidden="true">
            →
          </span>
          <span className="step-arrow" aria-hidden="true">
            →
          </span>
          <span className="step-arrow" aria-hidden="true">
            →
          </span>
          <span className="step-arrow" aria-hidden="true">
            →
          </span>
        </div>

        <div className="reveal">
          <img
            src="/assets/icons/workflow-main.png"
            alt=""
            aria-hidden="true"
            width="368"
            height="368"
            className="section-icon"
            loading="lazy"
          />
          <h2 id="workflow-title" className="heading-2">
            하나의 플랫폼으로
            <br />
            <span className="text-brand-600">수집에서 보고서까지.</span>
          </h2>
        </div>
      </div>
    </section>
  );
}
